import actions from "./actions";
import mutations from "./mutations";

const state = {
  mini: false,
  res_menu: [],
  idMenu: null,
  idPass: null,
  temp_pass: [],
  res_progres: [],
  idUser: null,
  temp_cekmenu: [],
  res_menucek: [],
  roles: []
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
